import { stats } from '@/mocks/site';

export default function StatsBand() {
  return (
    <section className="relative z-20 w-full px-4 md:px-8 -mt-10 md:-mt-14">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {stats.map((item) => (
          <div
            key={item.label}
            className="bg-background-50 border border-background-200 rounded-2xl p-4 md:p-6 flex flex-col gap-2"
          >
            <span className="w-10 h-10 rounded-xl bg-primary-100 text-primary-700 flex items-center justify-center text-xl">
              <i className={item.icon}></i>
            </span>
            <p className="text-2xl md:text-3xl text-foreground-950 font-heading">
              {item.value}
              <span className="text-base md:text-lg text-primary-600 ml-0.5">{item.suffix}</span>
            </p>
            <p className="text-xs md:text-sm text-foreground-600">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}